export default __webpack_public_path__ + "static/media/maintenance.619ab737.png";